import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RegressionComponent from './../Components/RegressionComponent.jsx';
import {
  dispatchers as dispatcherActions,
  annotations as annotationActions,
  params as paramActions
} from './../actions';
import {
  getDispatcherType,
  getDispatcherNameNumberJobIdPairs,
  getPageType
} from './../reducers';
import { dispatcher as dispatcherSelectors } from '../selectors';
import { regressionPages } from './../helpers';
export class RegressionContainer extends Component {
    static propTypes = {
      fetchRecentDispatchersByType: PropTypes.func.isRequired,
      fetchDispatcherByNameAndNumber: PropTypes.func.isRequired,
      fetchParamsByJobIds: PropTypes.func.isRequired,
      dispatcherJobIds: PropTypes.arrayOf(PropTypes.number).isRequired,
      fetchScenariosAnnotations: PropTypes.func.isRequired,
      nameNumberIdPairs: PropTypes.object.isRequired,
      dispatcherType: PropTypes.string,
      jobInfo: PropTypes.shape({
        jobId: PropTypes.oneOfType[
          PropTypes.string, PropTypes.number],
        jobName: PropTypes.string,
        jobNumber: PropTypes.oneOfType[PropTypes.string, PropTypes.number],
        recentDispatcherJobs: PropTypes.array
      }).isRequired,
      pageType: PropTypes.object.isRequired
    };

    componentDidMount() {
      this.props.fetchRecentDispatchersByType(
        this.props.dispatcherType, regressionPages.FETCH_DAYS);

      if (this.props.jobInfo && this.props.jobInfo.jobName &&
        this.props.jobInfo.jobNumber && parseInt(this.props.jobInfo.jobNumber) > 0) {
        const jobId = this.props.nameNumberIdPairs[
          `${this.props.jobInfo.jobName}_${this.props.jobInfo.jobNumber}`];
        if (!jobId)
        {
          this.props.fetchDispatcherByNameAndNumber(this.props.jobInfo.jobName,
            parseInt(this.props.jobInfo.jobNumber));
        }
      }

      this.props.fetchScenariosAnnotations();
    }

    componentDidUpdate = (prevProps) => {
      if ((this.props.dispatcherJobIds.length !== prevProps.dispatcherJobIds.length) ||
      (this.props.dispatcherJobIds[0] !== prevProps.dispatcherJobIds[0]))
      {
        this.props.fetchParamsByJobIds(this.props.dispatcherJobIds);
      }

      if (this.props.jobInfo.jobName !== prevProps.jobInfo.jobName ||
        this.props.jobInfo.jobNumber !== prevProps.jobInfo.jobNumber &&
          parseInt(this.props.jobInfo.jobNumber) > 0) {
        const jobNameNumber =
           `${this.props.jobInfo.jobName}_${this.props.jobInfo.jobNumber}`;
        const jobId = this.props.nameNumberIdPairs[jobNameNumber];

        if (jobId === undefined)
        {
          this.props.fetchDispatcherByNameAndNumber(jobNameNumber);
        }
      }
      this.props.fetchScenariosAnnotations();
    }

    render() {
      return (
        <RegressionComponent
          dispatcherType = {this.props.dispatcherType}
          jobInfo = {this.props.jobInfo}
          pageType = {this.props.pageType}
        />
      );
    }
}
export const mapStateToProps = (state) => {
  const dispatcherJobsByName =
  dispatcherSelectors.recentDispatchersAndJobsByName(state)['jobs'] || {};
  const jobInfo = dispatcherSelectors.getDispatcherJobInfo(state);
  const dispatcherJobs = dispatcherJobsByName[jobInfo.jobName];
  const dispatcherJobIds =
  dispatcherJobs ? dispatcherJobs.map(job => job.id) : [];
  const props = {
    dispatcherType: getDispatcherType(state),
    jobInfo,
    dispatcherJobIds,
    nameNumberIdPairs: getDispatcherNameNumberJobIdPairs(state),
    pageType: getPageType(state)
  };
  return props;
};

export default connect(
  mapStateToProps,
  {
    fetchRecentDispatchersByType: dispatcherActions.fetchRecentDispatchersByType,
    fetchDispatcherByNameAndNumber: dispatcherActions.fetchDispatcherByNameAndNumber,
    fetchScenariosAnnotations : annotationActions.fetchScenariosAnnotations,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
  }
)(RegressionContainer);


// WEBPACK FOOTER //
// src/Containers/RegressionContainer.jsx